import React from "react";
// TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import OpcUaTextField from "./OpcUaTextField";

/**
 * Connection-scoped OPC UA settings on the adapter CDO. The endpoint URL
 * itself moved to the Channel (see `StepChannels.tsx`'s
 * `isValidOpcUaEndpointUrl`/`opcUaEndpointUrl` field) since the connection
 * target belongs to the channel, not the per-adapter mapping config
 * (flatbuffer_schemas 0697cf91).
 */
export default function ConnectionEditor({
  applicationName,
  onChangeApplicationName,
}: {
  applicationName: string;
  onChangeApplicationName: (value: string) => void;
}) {
  const [t] = useTranslation("global");

  return (
    <div className="container" style={{ width: "100%", maxWidth: "none" }}>
      <div className="row">
        <div className="col-12 mt-3">
          <OpcUaTextField
            label="Application Name"
            value={applicationName}
            onChange={onChangeApplicationName}
            tooltip={t("general.opcUaApplicationNameHelp")}
          />
        </div>
      </div>
    </div>
  );
}
